import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { makeStyles } from "@material-ui/core/styles";

import Modal from "@material-ui/core/Modal";
import Fade from "@material-ui/core/Fade";
import Paper from "@material-ui/core/Paper";
import { Button } from "@material-ui/core";
import { defaultPasscodeTheme } from "../../../../../constants/passCodeUtils";
import { setEditingOnTicket } from "../../../../../actions/projectmail";

const useStyles = makeStyles(theme => ({
  ...defaultPasscodeTheme(theme),
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  inline: {
    display: "flex",
    maxWidth: "100%",
    flexWrap: "wrap",
  },
  modalContainer: {
    width: "700px",
    backgroundColor: "#eee",
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2),
  },
  bottomPadding: {
    paddingBottom: theme.spacing(1),
  },
  content: {
    padding: theme.spacing(1),
  },
  button: {
    padding: theme.spacing(0, 1),
  },
  spaceButtons: { flex: 1 },
  modalTitle: {
    fontWeight: "bold",
    fontSize: "20px",
  },
}));

const EditModalWarningComponent = ({ row, setOpenModal, openModal, setEditingOnTicketFn, translate }) => {
  const classes = useStyles();
  return (
    <Modal
      key="Email-Ticket-System-Modal"
      open={openModal}
      className={classes.modal}
      onClose={() => setOpenModal(false)}
    >
      <Fade in={openModal}>
        <div key="modalContainer" className={classes.modalContainer}>
          <Paper>
            <div className={classes.content}>
              <div className={classes.modalTitle}>{translate.warning}</div>
              <div className={classes.bottomPadding} />
              <div>{translate.isUserAssigned.replace("{0}", row.owner)}</div>
              <div>{translate.overrideAssign}</div>
            </div>
          </Paper>
          <div className={classes.bottomPadding} />
          <div className={`${classes.inline}`}>
            <div className={classes.button}>
              <Button
                size="small"
                color="primary"
                variant="contained"
                onClick={() => {
                  setEditingOnTicketFn(row.id);
                  window.open("https://zammad.ubivent.net/#ticket/zoom/" + row.id, "zammad");
                  setOpenModal(false);
                }}
              >
                {translate.yes}
              </Button>
            </div>
            <div className={classes.button}>
              <Button
                size="small"
                color="secondary"
                variant="contained"
                onClick={() => {
                  window.open("https://zammad.ubivent.net/#ticket/zoom/" + row.id, "zammad");
                  setOpenModal(false);
                }}
              >
                {translate.no}
              </Button>
            </div>
            <div className={classes.spaceButtons} />
            <div className={classes.button}>
              <Button
                color="default"
                size="small"
                onClick={() => {
                  setOpenModal(false);
                }}
              >
                {translate.cancel}
              </Button>
            </div>
          </div>
        </div>
      </Fade>
    </Modal>
  );
};

EditModalWarningComponent.propTypes = {
  translate: PropTypes.object.isRequired,
  setOpenModal: PropTypes.func.isRequired,
  openModal: PropTypes.bool.isRequired,
  setEditingOnTicketFn: PropTypes.func.isRequired,
  row: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  translate: state.ui.translate,
});

const mapDispatchToProps = dispatch => ({
  setEditingOnTicketFn: id => dispatch(setEditingOnTicket(id, true)),
});

const EditModalWarning = connect(
  mapStateToProps,
  mapDispatchToProps
)(EditModalWarningComponent);

export default EditModalWarning;
